import { object, string, array, mixed } from 'yup';
import type { AssetID, EventID } from '@common/ids';
import { convertSnakeCaseIntoCamelCase, makeUUIDSchema } from './helper';

export const AssetPlaybackDataSchema = object({
    id: makeUUIDSchema<AssetID>().required(),
    scheduleEventID: makeUUIDSchema<EventID>().required(),
    url: string().required(),
    cookies: mixed(),
}).transformKeys(convertSnakeCaseIntoCamelCase);

export const AssetPlaybackDataListSchema = array(AssetPlaybackDataSchema).required();
